import React from 'react';
import { X, AlertCircle, Check, Loader2 } from 'lucide-react';

const CreditModal = ({ setShowCreditModal, handlePurchaseCredits, isLoadingCheckout }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-gray-900">Purchase Credits</h3>
          <button
            onClick={() => setShowCreditModal(false)}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        
        <div className="mb-6 p-4 bg-gradient-to-r from-red-50 to-orange-50 rounded-lg border border-red-200">
          <div className="flex items-center gap-2 text-red-800 mb-2">
            <AlertCircle className="w-5 h-5" />
            <span className="font-semibold">No Credits Remaining</span>
          </div>
          <p className="text-sm text-gray-700">
            You've used all your free credits. Purchase more credits to continue processing invoices.
          </p>
        </div>

        <div className="space-y-3 mb-6">
          {/* Standard Plan */}
          <button
            onClick={() => handlePurchaseCredits(30, 5.00)}
            disabled={isLoadingCheckout}
            className="w-full border-2 border-indigo-200 rounded-lg p-4 hover:border-indigo-400 transition-colors bg-gradient-to-r from-indigo-50 to-purple-50 text-left hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <span className="font-bold text-lg text-gray-900">30 Credits</span>
                <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded">
                  STANDARD
                </span>
              </div>
              <span className="text-2xl font-bold text-indigo-600">$5.00</span>
            </div>
            <p className="text-xs text-gray-600">$0.17 per credit</p>
          </button>

          {/* Popular Plan */}
          <button
            onClick={() => handlePurchaseCredits(100, 10.00)}
            disabled={isLoadingCheckout}
            className="w-full border-2 border-purple-300 rounded-lg p-4 hover:border-purple-500 transition-colors bg-gradient-to-r from-purple-50 to-pink-50 text-left hover:shadow-md relative disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
              <span className="px-3 py-1 bg-green-500 text-white text-xs font-bold rounded-full shadow-md">
                POPULAR
              </span>
            </div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <span className="font-bold text-lg text-gray-900">100 Credits</span>
                <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded">
                  Save 41%
                </span>
              </div>
              <span className="text-2xl font-bold text-purple-600">$10.00</span>
            </div>
            <p className="text-xs text-gray-600">$0.10 per credit • You save $6.67!</p>
          </button>

          {/* Best Value */}
          <button
            onClick={() => handlePurchaseCredits(310, 30.00)}
            disabled={isLoadingCheckout}
            className="w-full border-2 border-pink-300 rounded-lg p-4 hover:border-pink-500 transition-colors bg-gradient-to-r from-pink-50 to-red-50 text-left hover:shadow-md relative disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
              <span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs font-bold rounded-full shadow-md">
                ⭐ BEST VALUE
              </span>
            </div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <span className="font-bold text-lg text-gray-900">310 Credits</span>
                <span className="px-2 py-0.5 bg-amber-100 text-amber-700 text-xs font-medium rounded">
                  Save 53%
                </span>
              </div>
              <span className="text-2xl font-bold text-pink-600">$30.00</span>
            </div>
            <p className="text-xs text-gray-600">$0.097 per credit • You save $34.00!</p>
          </button>
        </div>

        {isLoadingCheckout && (
          <div className="text-center py-4 mb-4">
            <Loader2 className="w-8 h-8 animate-spin text-indigo-600 mx-auto mb-2" />
            <p className="text-sm text-gray-600">Redirecting to secure checkout...</p>
          </div>
        )}

        <div className="border-t border-gray-200 pt-4">
          <p className="text-xs text-gray-500 text-center mb-3">
            🔒 Secure payment powered by Stripe • 256-bit encryption
          </p>
          <div className="flex items-center justify-center gap-4 text-xs text-gray-400">
            <div className="flex items-center gap-1">
              <Check className="w-3 h-3 text-green-500" />
              <span>No subscription</span>
            </div>
            <div className="flex items-center gap-1">
              <Check className="w-3 h-3 text-green-500" />
              <span>Credits never expire</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditModal;